module.exports = __webpack_public_path__ + "img/logo.1f5b2b02.png";